import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Message } from 'primeng/primeng';
import { Router } from "@angular/router";

import { ISPEDSecurityUser } from './Models/ISPEDSecurityUser';
import { IepFormTypeEnum } from './Models/Enums/IepFormTypeEnum';
import { IAdminPlacement } from './Models/IAdminPlacement';
import { ICanAddDocuments } from './Models/ICanAddDocuments';
import { IDashboardDocument } from './Models/IDashboardDocument';
import { IIepFormControl } from './Models/IIepFormControl';
import { IFormDetails } from './../app/Models/IFormDetails';
import { IMsalResponse } from './Models/IMsalResponse';
import { ISelectedStudent } from './Models/ISelectedStudent';
import { ISpedStudentDemographics } from './Models/ISpedStudentDemographics';
import { IReportRequest } from './../app/Models/IReportRequest';
import { IReportParameter } from './../app/Models/IReportParameter';
import { IReportPDF } from './../app/Models/IReportPDF';
import { ILookupBase } from './../app/Models/ILookupBase';
import { IActivityLog } from './../app/Models/IActivityLog';
import { IStudentMinimal } from './../app/Models/IStudentMinimal';
import { IProgressReportBasicData } from './../app/Models/IProgressReportBasicData';
import { IStudentEnrollment } from './../app/Models/IStudentEnrollment'
import { ISubstituteServiceProvider } from './../app/Models/ISubstituteServiceProvider'
import { saveAs } from './../../node_modules/file-saver/src/FileSaver';

import { AdminPlacementService } from "./Services/AdminPlacementService";
import { DashboardDocumentService } from "./Services/DashboardDocumentService";
import { IepService } from './Services/IepService';
import { ReportService } from './Services/ReportService';
import { ActivityLogService } from './Services/ActivityLogService';
import { MaintenanceService } from './Services/MaintenanceService';
import { StudentService } from './Services/StudentService'

//Accomodations
import { IFormAccomodations } from './Models/Forms/IFormAccomodations';
import { FormAccomodationsService } from './Services/FormAccomodationsService';

//AgeOfMajority17
import { IFormAgeOfMajority17 } from './Models/Forms/IFormAgeOfMajority17';
import { FormAgeOfMajority17Service } from './Services/FormAgeOfMajority17Service';

//AgeOfMajority18
import { IFormAgeOfMajority18 } from './Models/Forms/IFormAgeOfMajority18';
import { FormAgeOfMajority18Service } from './Services/FormAgeOfMajority18Service';

//AssessmentTeamSummary
import { IFormAssessmentTeamSummary } from './Models/Forms/IFormAssessmentTeamSummary';
import { FormAssessmentTeamSummaryService } from './Services/FormAssessmentTeamSummaryService';

//AuthorizationForDisclosureService
import { IFormAuthorizationForDisclosure } from './Models/Forms/IFormAuthorizationForDisclosure';
import { FormAuthorizationForDisclosureService } from './Services/FormAuthorizationForDisclosureService';

//BehaviorPlan
import { IFormBehaviorPlan } from './Models/Forms/IFormBehaviorPlan';
import { FormBehaviorPlanService } from './Services/FormBehaviorPlanService';

//CaliforniaAssessmentTest
import { IFormCaliforniaAssessmentTest } from './Models/Forms/IFormCaliforniaAssessmentTest';
import { FormCaliforniaAssessmentTestService } from './Services/FormCaliforniaAssessmentTestService';

//ConferenceFollowup
import { IFormConferenceFollowup } from './Models/Forms/IFormConferenceFollowup';
import { FormConferenceFollowupService } from './Services/FormConferenceFollowupService';

//ELReclassification
import { IFormELReclassification } from './Models/Forms/IFormELReclassification';
import { FormELReclassificationService } from './Services/FormELReclassificationService';

//ESY Survey
import { IFormESYSurvey } from './Models/Forms/IFormESYSurvey';
import { FormESYSurveyService } from './Services/FormESYSurveyService';

//ESY Eligibility Worksheet
import { IFormESYEligibilityWorksheet } from './Models/Forms/IFormESYEligibilityWorksheet';
import { FormESYEligibilityWorksheetService } from './Services/FormESYEligibilityWorksheetService';

//GoalsAndBenchmarks
import { IFormGoalsAndBenchmarks } from './Models/Forms/IFormGoalsAndBenchmarks';
import { FormGoalsAndBenchmarksService } from './Services/FormGoalsAndBenchmarksService';

//IndividualizedTransitionPlan
import { IFormIndividualizedTransitionPlan } from './Models/Forms/IFormIndividualizedTransitionPlan';
import { FormIndividualizedTransitionPlanService } from './Services/FormIndividualizedTransitionPlanService';

//LAGO
import { IFormLAGO } from './Models/Forms/IFormLAGO';
import { FormLAGOService } from './Services/FormLAGOService';

//Manifestation Determination
import { IFormManifestationDetermination } from './Models/Forms/IFormManifestationDetermination';
import { FormManifestationDeterminationService } from './Services/FormManifestationDeterminationService';

//Meeting SignIn 
import { IFormMeetingSignIn } from './Models/Forms/IFormMeetingSignIn';
import { FormMeetingSignInService } from './Services/FormMeetingSignInService';

//Meeting Notification
import { IFormConferenceInvitation } from './Models/Forms/IFormConferenceInvitation';
import { FormConferenceInvitationService } from './Services/FormConferenceInvitationService';

//Notes
import { IFormNotes } from './Models/Forms/IFormNotes';
import { FormNotesService } from './Services/FormNotesService';

//NoticeOfIntent 
import { IFormNoticeOfIntent } from './Models/Forms/IFormNoticeOfIntent';
import { FormNoticeOfIntentService } from './Services/FormNoticeOfIntentService';

//NotificationOfAppeal
import { IFormNotificationOfAppeal } from './Models/Forms/IFormNotificationOfAppeal';
import { FormNotificationOfAppealService } from './Services/FormNotificationOfAppealService';

//PermToAssess
import { IFormPermissionToAssess } from './Models/Forms/IFormPermissionToAssess';
import { FormPermissionToAssessService } from './Services/FormPermissionToAssessService';

//PermToAssessRemind
import { IFormPermToAssessRemind } from './Models/Forms/IFormPermToAssessRemind';
import { FormPermToAssessRemindService } from './Services/FormPermToAssessRemindService';

//PlanningForFuture
import { IFormPlanningForTheFuture } from './Models/Forms/IFormPlanningForTheFuture';
import { FormPlanningForTheFutureService } from './Services/FormPlanningForTheFutureService';

//PresentLevels
import { IFormPresentLevels } from './Models/Forms/IFormPresentLevels';
import { FormPresentLevelsService } from './Services/FormPresentLevelsService';

//PsychomotorObservation

//Revoking Consent
import { IFormRevokingConsent } from "./Models/Forms/IFormRevokingConsent";
import { FormRevokingConsentService } from './Services/FormRevokingConsentService';

//Signature
import { IFormSignature } from './Models/Forms/IFormSignature';
import { FormSignatureService } from './Services/FormSignatureService';

//Special Factors
import { IFormSpecialFactors } from "./Models/Forms/IFormSpecialFactors";
import { FormSpecialFactorsService } from './Services/FormSpecialFactorsService';

//Student Information
import { IFormStudentInformation } from "./Models/Forms/IFormStudentInformation";
import { FormStudentInformationService } from './Services/FormStudentInformationService';

//SummaryOfPerformance
import { IFormSummaryOfPerformance } from './Models/Forms/IFormSummaryOfPerformance';
import { FormSummaryOfPerformanceService } from './Services/FormSummaryOfPerformanceService';

//SurrogateParentAppointment
import { IFormSurrogateParentAppointment } from './Models/Forms/IFormSurrogateParentAppointment';
import { FormSurrogateParentAppointmentService } from './Services/FormSurrogateParentAppointmentService';

//VisionHearing
import { IFormVisionHearing } from './Models/Forms/IFormVisionHearing';
import { FormVisionHearingService } from './Services/FormVisionHearingService';

////EmergencyServicesOptions
import { IFormEmergencyServicesOptions } from './Models/Forms/IFormEmergencyServicesOptions';
import { FormEmergencyServicesOptionsService } from './Services/FormEmergencyServicesOptions.service';

import { SecurityService } from './Services/SecurityService';


import { IIEPMenuItem } from './Models/IIepMenuItem';
import { IIepInstance } from './Models/IIepInstance';

//import { Date } from 'core-js';
//import { CanDeactivate } from '@angular/router/src/utils/preactivation';
//import { IFormTransitionPlanning } from './Models/Forms/IFormTransitionPlanning';

@Injectable()
export class Globals {
  _baseUrl: string;
  _iepService: IepService;
  editMode: boolean;

  calendarYearRangeSchoolYear: string;
  calendarYearRangePastYear: string;
  calendarYearRangePast3Years: string;
  calendarYearRangeNextYear: string;
  calendarYearRangeNext2SchoolYears: string;
  calendarYearRangeNext3Years: string;
  calendarYearPlusMinusOne: string;
  reportSelected: string = "0";
  serDocSelected: string = "0";
  stdSerSelected: string = "0";
  //childfindSelectedID: number = 0;
  //sptprocesSelectedID: number = 0;

  _formAccomodationsService: FormAccomodationsService;
  _formAgeOfMajority17Service: FormAgeOfMajority17Service;
  _formAgeOfMajority18Service: FormAgeOfMajority18Service;
  _formAssessmentTeamSummaryService: FormAssessmentTeamSummaryService;
  _formAuthorizationForDisclosureService: FormAuthorizationForDisclosureService;
  _formBehaviorPlanService: FormBehaviorPlanService;
  _formCaliforniaAssessmentTestService: FormCaliforniaAssessmentTestService;
  _formConferenceFollowupService: FormConferenceFollowupService;
  _formConferenceInvitationService: FormConferenceInvitationService;
  _formELReclassificationService: FormELReclassificationService;
  _formEmergencyServicesOptionsService: FormEmergencyServicesOptionsService;
  _formESYSurveyService: FormESYSurveyService;
  _formESYEligibilityWorksheetService: FormESYEligibilityWorksheetService;
  _formGoalsAndBenchmarksService: FormGoalsAndBenchmarksService;
  _formIndividualizedTransitionPlanService: FormIndividualizedTransitionPlanService;
  _formLAGOService: FormLAGOService;
  _formManifestationDeterminationService: FormManifestationDeterminationService;
  _formMeetingSignInService: FormMeetingSignInService;
  _formNotesService: FormNotesService;
  _formNoticeOfIntentService: FormNoticeOfIntentService;
  _formNotificationOfAppealService: FormNotificationOfAppealService;
  _formPermissionToAssessService: FormPermissionToAssessService;
  _formPermToAssessRemindService: FormPermToAssessRemindService;
  _formPresentLevelsService: FormPresentLevelsService;
  _formRevokingConsentService: FormRevokingConsentService;
  _formSignatureService: FormSignatureService;
  _formSpecialFactorsService: FormSpecialFactorsService;
  _formStudentInformationService: FormStudentInformationService;
  _formSummaryOfPerformanceService: FormSummaryOfPerformanceService;
  _formSurrogateParentAppointmentService: FormSurrogateParentAppointmentService;
  _formPlanningForTheFutureService: FormPlanningForTheFutureService;
  _formVisionHearingService: FormVisionHearingService;
  _securityService: SecurityService;
  _dashboardDocumentService: DashboardDocumentService;
  _adminPlacementService: AdminPlacementService;
  _reportService: ReportService;
  _activityLogService: ActivityLogService;
  _maintenanceService: MaintenanceService;
  _studentService: StudentService;

  _http: HttpClient;
  iepApMenuItemsIsDirty: boolean;
  leftMenuItems: MenuItem[];
  leftMenuItemsDisabled: MenuItem[];
  studentSearchMenuItems: MenuItem[];
  studentSearchMenuItemsDisabled: MenuItem[];
  iepApMenuItems: MenuItem[];
  iepApMenuItemsDisabled: MenuItem[];

  _selectedStudent: ISelectedStudent;
  get selectedStudent(): ISelectedStudent {
    return this._selectedStudent;
  }
  set selectedStudent(value: ISelectedStudent) {
    this._selectedStudent = value;

    if (this._selectedStudent != null && this._selectedStudent.spedStatus == null) {
      this._selectedStudent.spedStatus = '';
    }
  }

  dashboardDocumentResults: IDashboardDocument[];
  selectedDashboardDocument: IDashboardDocument;
  canAddDocuments: ICanAddDocuments;
  iepFormControl: IIepFormControl;
  spedStudentDemographics: ISpedStudentDemographics;
  adminPlacement: IAdminPlacement;
  selectedIIEPMenuItem: IIEPMenuItem;
  selectedIepInstance: IIepInstance;
  selectedFormDetails: IFormDetails;
  msalResponse: IMsalResponse;
  
  selectedFormInstanceId: number;

  // Note: the following public fields are used the the maintenance page. 
  public studentIepInstances: IIepInstance[];
  public studentAdminPlacements: IAdminPlacement[];
  public studentMinimal: IStudentMinimal;
  public primaryDisibility: string;
  public secondaryDisability: string;
  public tertiaryDisability: string;
  public quaternaryDisability: string;

  spedSecurityUser: ISPEDSecurityUser;
  studentSearchIsVisible: boolean;
  iepInformationIsVisible: boolean;
  adminPlacementIsVisible: boolean;
  initialIepInfoIsVisible: boolean;
  studentEnrollmentsIsVisible: boolean;
  documentDashboardIsVisible: boolean;
  includeInactiveStudents: boolean;
  disableButtonCreateNewAdminPlacement: boolean;
  disableButtonCreateNewIEP: boolean;
  disableButtonCreateAddendum: boolean;
  currentOfficialDocumentIsIEP: boolean;
  currentOfficialDocumentIsAP: boolean;
  messages: Message[];
  allowedMeetingTypes: ILookupBase[];
  deployDate: Date = new Date('5/20/2021');
  public todaysDate: Date = new Date();
  public schoolYearStartDate: Date;
  public schoolYearEndDate: Date;
  public previousSchoolYearStartDate: Date;
  public isAddendumInProgress: boolean = false;

  studentPTAs: IFormPermissionToAssess[];
  studentPTAs2: ILookupBase[];

  public showIepMenuItemsSpinner: boolean;
  public showMaintenanceSpinner: boolean;
  public securityCanUserEdit: boolean;
  public securityCanDocumentBeEdited: boolean = false;
  public canUserEditAllActivityLogs: boolean = false;
  public canUserCancelIep: boolean = false;
  public spedSecurityUsername: string;
  public activityLogs: IActivityLog[];
  public progressReportBasicDataArray: IProgressReportBasicData[];
  public progressReportFullBasicDataArray: IProgressReportBasicData[];
  public studentEnrollments: IStudentEnrollment[];

  public substitutingForServiceProvider: ISubstituteServiceProvider;

  currentOfficialAdminPlacementId: number;
  currentOfficialIepInstanceId: number;

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private router: Router,
    iepService: IepService,
    reportService: ReportService,
    formAccomodationsService: FormAccomodationsService,
    formAgeOfMajority17Service: FormAgeOfMajority17Service,
    formAgeOfMajority18Service: FormAgeOfMajority18Service,
    formAssessmentTeamSummaryService: FormAssessmentTeamSummaryService,
    formAuthorizationForDisclosureService: FormAuthorizationForDisclosureService,
    formBehaviorPlanService: FormBehaviorPlanService,
    formCaliforniaAssessmentTestService: FormCaliforniaAssessmentTestService,
    formConferenceInvitationService: FormConferenceInvitationService,
    formConferenceFollowupService: FormConferenceFollowupService,
    formELReclassificationService: FormELReclassificationService,
    private formEmergencyServicesOptionsService: FormEmergencyServicesOptionsService,
    formESYSurveyService: FormESYSurveyService,
    formESYEligibilityWorksheetService: FormESYEligibilityWorksheetService,
    formGoalsAndBenchmarksService: FormGoalsAndBenchmarksService,
    formIndividualizedTransitionPlanService: FormIndividualizedTransitionPlanService,
    formLAGOService: FormLAGOService,
    formManifestationDeterminationService: FormManifestationDeterminationService,
    formMeetingSignInService: FormMeetingSignInService,
    formNotesService: FormNotesService,
    formNoticeOfIntentService: FormNoticeOfIntentService,
    formNotificationOfAppealService: FormNotificationOfAppealService,
    formPermissionToAssessService: FormPermissionToAssessService,
    formPermToAssessRemindService: FormPermToAssessRemindService,
    formPlanningForTheFutureService: FormPlanningForTheFutureService,
    formPresentLevelsService: FormPresentLevelsService,
    formRevokingConsentService: FormRevokingConsentService,
    formSignatureService: FormSignatureService,
    formSpecialFactorsService: FormSpecialFactorsService,
    formStudentInformationService: FormStudentInformationService,
    formSummaryOfPerformanceService: FormSummaryOfPerformanceService,
    formSurrogateParentAppointmentService: FormSurrogateParentAppointmentService,
    formVisionHearingService: FormVisionHearingService,
    dashboardDocumentService: DashboardDocumentService,
    adminPlacementService: AdminPlacementService,
    activityLogService: ActivityLogService,
    maintenanceService: MaintenanceService,
    studentService: StudentService) {
    this._baseUrl = baseUrl;
    this._http = http;
    this._iepService = iepService;
    this._formAccomodationsService = formAccomodationsService;
    this._formAgeOfMajority17Service = formAgeOfMajority17Service;
    this._formAgeOfMajority18Service = formAgeOfMajority18Service;
    this._formAssessmentTeamSummaryService = formAssessmentTeamSummaryService;
    this._formAuthorizationForDisclosureService = formAuthorizationForDisclosureService;
    this._formBehaviorPlanService = formBehaviorPlanService;
    this._formCaliforniaAssessmentTestService = formCaliforniaAssessmentTestService;
    this._formConferenceInvitationService = formConferenceInvitationService;
    this._formConferenceFollowupService = formConferenceFollowupService;
    this._formELReclassificationService = formELReclassificationService;
    this._formESYSurveyService = formESYSurveyService;
    this._formESYEligibilityWorksheetService = formESYEligibilityWorksheetService;
    this._formGoalsAndBenchmarksService = formGoalsAndBenchmarksService;
    this._formIndividualizedTransitionPlanService = formIndividualizedTransitionPlanService;
    this._formLAGOService = formLAGOService;
    this._formManifestationDeterminationService = formManifestationDeterminationService;
    this._formMeetingSignInService = formMeetingSignInService;
    this._formNotesService = formNotesService;
    this._formNoticeOfIntentService = formNoticeOfIntentService;
    this._formNotificationOfAppealService = formNotificationOfAppealService;
    this._formPermToAssessRemindService = formPermToAssessRemindService;
    this._formPermissionToAssessService = formPermissionToAssessService;
    this._formPlanningForTheFutureService = formPlanningForTheFutureService;
    this._formPresentLevelsService = formPresentLevelsService;
    this._formRevokingConsentService = formRevokingConsentService;
    this._formSignatureService = formSignatureService;
    this._formSpecialFactorsService = formSpecialFactorsService;
    this._formStudentInformationService = formStudentInformationService;
    this._formSummaryOfPerformanceService = formSummaryOfPerformanceService;
    this._formVisionHearingService = formVisionHearingService;
    this._formSurrogateParentAppointmentService = formSurrogateParentAppointmentService;
    this._dashboardDocumentService = dashboardDocumentService;
    this._adminPlacementService = adminPlacementService;
    this._activityLogService = activityLogService;
    this._maintenanceService = maintenanceService;
    this._studentService = studentService;
    this.iepFormControl = {} as IIepFormControl;
    this.adminPlacementIsVisible = false;
    this._reportService = reportService;
    this.studentSearchMenuItems = [
      { label: 'Student Search', command: (event: Event) => { this.selectedIepMenuItem(0) } }
    ]
    this.studentSearchMenuItemsDisabled = [
      { label: 'Student Search', command: (event: Event) => { this.selectedIepMenuItem(0) } , disabled: true }
    ]
    this.iepApMenuItems = this.studentSearchMenuItems;

    let todaysDate = new Date();
    this.todaysDate = todaysDate;
    this.schoolYearStartDate = todaysDate.getMonth() >= 6 ? new Date(todaysDate.getFullYear(), 6, 1) : new Date(todaysDate.getFullYear() - 1, 6, 1);
    this.schoolYearEndDate = todaysDate.getMonth() >= 6 ? new Date(todaysDate.getFullYear() + 1, 5, 30) : new Date(todaysDate.getFullYear(), 5, 30);
    this.previousSchoolYearStartDate = todaysDate.getMonth() >= 6 ? new Date(todaysDate.getFullYear() - 1, 6, 1) : new Date(todaysDate.getFullYear() - 2, 6, 1);
    let currentYear = todaysDate.getFullYear();

    this.calendarYearRangeSchoolYear = this.schoolYearStartDate.getFullYear().toString() + ':' + this.schoolYearEndDate.getFullYear().toString()
    this.calendarYearRangePastYear = (todaysDate.getFullYear() - 1).toString() + ':' + todaysDate.getFullYear().toString()
    this.calendarYearRangePast3Years = (todaysDate.getFullYear() - 2).toString() + ':' + todaysDate.getFullYear().toString()
    this.calendarYearRangeNextYear = todaysDate.getFullYear().toString() + ':' + (todaysDate.getFullYear() + 1).toString()
    this.calendarYearRangeNext3Years = todaysDate.getFullYear().toString() + ':' + (todaysDate.getFullYear() + 2).toString()
    this.calendarYearRangeNext2SchoolYears = this.schoolYearStartDate.getFullYear().toString() + ':' + (this.schoolYearEndDate.getFullYear()+1).toString()
    this.calendarYearPlusMinusOne = (todaysDate.getFullYear() - 1).toString() + ':' + (todaysDate.getFullYear() + 1).toString()

  }

  public deleteCurrentForm() {
    if (this.selectedIepInstance != null && (this.selectedIepInstance.statusId == 1 || this.selectedIepInstance.statusId == 5)) {
      if (confirm("Do you want to delete this form? ")) {
        this._iepService.deleteIEPForm(this.selectedFormDetails.formInstanceId).subscribe((result: string) => {
          if (result == 'Form successfully deleted.') {
            this.editMode = false;
            this.rebuildIepMenuItems(this.selectedFormDetails.iepInstanceId);
          }
        },
          err => console.error(err)
        );
      }
    }
  };

  public setSelectedStudent(selectedStudent: ISelectedStudent) {
    this.selectedStudent = selectedStudent;

    if (this.selectedStudent.spedStatus == null) {
      this.selectedStudent.spedStatus = 'U';
    }

    this.studentSearchIsVisible = false;
    this._activityLogService.getAllActivityLogForStudent(this.selectedStudent.localStudentId + '^0').subscribe((res: IActivityLog[]) => {
      this.activityLogs = res;
      this.activityLogs.forEach((log, index, logs) => {
        log.activityDateStr = new Date(log.activityDate).toISOString().slice(0, 10);
        log.createdDateStr = new Date(log.createdDate).toISOString().slice(0, 10);
        log.comment = log.comment.substr(0, 20).concat(' ...');
      });
    },
      err => console.error(err)
    );

    this._dashboardDocumentService.getAllowedMeetingTypes(this._baseUrl + 'api/DashboardDocument/GetAllowedMeetingTypes?localStudentId=' + this.selectedStudent.localStudentId).subscribe((res: ILookupBase[]) => {
      this.allowedMeetingTypes = [] as ILookupBase[];
      this.allowedMeetingTypes.push({ label: 'Select a Meeting Type', value: null, shortText: 'Select a Meeting Type', updatedOn: null });
      this.allowedMeetingTypes.push.apply(this.allowedMeetingTypes, res);
    },
      err => console.error(err)
    );

    this._dashboardDocumentService.get(this._baseUrl + 'api/DashboardDocument/' + this.selectedStudent.localStudentId).subscribe((res: IDashboardDocument[]) => {
      this.dashboardDocumentResults = res as IDashboardDocument[];
      this.controlAddButtons();
      this.findCurrentOfficialDocument();
      console.log(this.dashboardDocumentResults);

      this.isAddendumInProgress = false;

      for (let item of this.dashboardDocumentResults) {
        if (item.documentType == "Addendum" && (item.status == "Draft" || item.status == "Meeting In Process" || item.status == "Print Signature")) {
          this.isAddendumInProgress = true;
        }
      }
    },
      err => console.error(err)
    );

    this._dashboardDocumentService.getCanAddDocuments(this._baseUrl + 'api/DashboardDocument/GetCanAddDocuments?localStudentId=' + this.selectedStudent.localStudentId).subscribe((res: ICanAddDocuments) => {
      this.canAddDocuments = res as ICanAddDocuments;
      this.controlAddButtons();
      //console.log(this.canAddDocuments);
    },
      err => console.error(err)
    );

    this.showMaintenanceSpinner = true;
    this._maintenanceService.getIepInstancesForStudent(this.selectedStudent.localStudentId).subscribe((res: IIepInstance[]) => {
      this.studentIepInstances = res as IIepInstance[];
      this.showMaintenanceSpinner = false;
    },
      err => {
        this.showMaintenanceSpinner = false;
        console.error(err);
      }
    );

    this._maintenanceService.getAdminPlacementsForStudent(this.selectedStudent.localStudentId).subscribe((res: IAdminPlacement[]) => {
      this.studentAdminPlacements = res as IAdminPlacement[];
      this.showMaintenanceSpinner = false;
    },
      err => {
        this.showMaintenanceSpinner = false;
        console.error(err);
      }
    );

    this._maintenanceService.getStudentMinimal(this.selectedStudent.localStudentId).subscribe((res: IStudentMinimal) => {
      this.studentMinimal = res as IStudentMinimal;
      this.primaryDisibility = this.studentMinimal.primaryDisability == null ? '' : this.studentMinimal.primaryDisability;
      this.secondaryDisability = this.studentMinimal.secondaryDisability == null ? '' : this.studentMinimal.secondaryDisability;
      this.tertiaryDisability = this.studentMinimal.tertiaryDisability == null ? '' : this.studentMinimal.tertiaryDisability;
      this.quaternaryDisability = this.studentMinimal.quaternaryDisability == null ? '' : this.studentMinimal.quaternaryDisability;
      this.showMaintenanceSpinner = false;
    },
      err => {
        this.showMaintenanceSpinner = false;
        console.error(err);
      }
    );

    this._maintenanceService.getStudentPTAs(this.selectedStudent.localStudentId).subscribe((res: IFormPermissionToAssess[]) => {
      this.studentPTAs = res as IFormPermissionToAssess[];
      this.studentPTAs2 = [] as ILookupBase[];
      this.studentPTAs2.push({ label: 'Select a Meeting Date', value: null, shortText: 'Select a Meeting Date', updatedOn: null });
      let counter: number = 0;
      for (let item of this.studentPTAs) {
        this.studentPTAs2.push({ label: item.meetingDate, value: counter.toString(), shortText: item.meetingDate, updatedOn: null });
        counter++;
      }

      this.showMaintenanceSpinner = false;
    },
      err => {
        this.showMaintenanceSpinner = false;
        console.error(err);
      }
    );

    this._studentService.getStudentEnrollments(this.selectedStudent.localStudentId).subscribe((res: IStudentEnrollment[]) => {
      this.studentEnrollments = res;
    },
      err => console.error(err)
    );

    this._iepService.getProgressReportBasicDataByStudent(this.selectedStudent.localStudentId).subscribe((res: IProgressReportBasicData[]) => {
      this.progressReportFullBasicDataArray = res as IProgressReportBasicData[];
    },
      err => {
        this.progressReportFullBasicDataArray = [];
        console.error(err);
      }
    );
  }

  findCurrentOfficialDocument() {
    this.currentOfficialAdminPlacementId = null;
    this.currentOfficialIepInstanceId = null;
    this.progressReportBasicDataArray = [] as IProgressReportBasicData[];

    for (let documentItem of this.dashboardDocumentResults) {
      if (documentItem.isCurrent) {
        this.currentOfficialAdminPlacementId = documentItem.adminPlacementId;
        this.currentOfficialIepInstanceId = documentItem.iepInstanceId;
      }
    }
      
    if (this.currentOfficialIepInstanceId != null && this.currentOfficialIepInstanceId > 0) {

      this._iepService.getProgressReportBasicData(this.currentOfficialIepInstanceId).subscribe((res: IProgressReportBasicData[]) => {
        this.progressReportBasicDataArray = res as IProgressReportBasicData[];
      },
        err => {
          this.showMaintenanceSpinner = false;
          console.error(err);
        }
      );
    }

  }

  controlAddButtons() {
    this.disableButtonCreateNewAdminPlacement = true;
    this.disableButtonCreateNewIEP = true;
    this.disableButtonCreateAddendum = true;

    this.currentOfficialDocumentIsIEP = false;
    this.currentOfficialDocumentIsAP = false;

    for (var dashDoc of this.dashboardDocumentResults) {
      if (dashDoc.isCurrent && dashDoc.status == 'Official') {
        if (dashDoc.adminPlacementId == null) {
          this.currentOfficialDocumentIsIEP = true;
        }
        else if (dashDoc.iepInstanceId == null) {
          this.currentOfficialDocumentIsAP = true;
        }
        break;
      }
    }

    if (this.canAddDocuments != null) {
      if (this.canAddDocuments.canAddIEP) {
        this.disableButtonCreateNewIEP = false;
        this.documentDashboardIsVisible = true;
      }

      if (this.canAddDocuments.canAddAP) {
        this.disableButtonCreateNewAdminPlacement = false;
        this.documentDashboardIsVisible = true;
      }

      if (this.canAddDocuments.canAddAddendum && this.currentOfficialDocumentIsIEP) {
        this.disableButtonCreateAddendum = false;
        this.documentDashboardIsVisible = true;
      }
    }
  }

  public canEdit() {
    return this.securityCanUserEdit && this.securityCanDocumentBeEdited;
  }

  public canEditInitialIEPInfo() {
    return this.securityCanUserEdit;
  }

  public documentSelected(selecedDocument: IDashboardDocument) {
    this.selectedDashboardDocument = selecedDocument;
    this.iepApMenuItems = this.studentSearchMenuItems;
    this.SetActiveIepFormType(null);
    switch (this.selectedDashboardDocument.status) {
      case 'Draft':
      case 'Meeting In Process':
        this.securityCanDocumentBeEdited = true;
        break;
      default:
        this.securityCanDocumentBeEdited = false;
        break;
    }

    this.adminPlacementIsVisible = false;
    this.iepInformationIsVisible = false;

    if (this.selectedDashboardDocument.iepInstanceId != null) {
      this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
    }
    else if (this.selectedDashboardDocument.adminPlacementId != null) {
      this.iepApMenuItems = [
        { label: 'Student Search', command: (event: Event) => { this.selectedIepMenuItem(0) } }
      ];

      this._dashboardDocumentService.getAPStudent(this._baseUrl + 'api/DashboardDocument/GetAPSpedStudentDemographics?adminPlacementId=' + this.selectedDashboardDocument.adminPlacementId).subscribe((res: ISpedStudentDemographics) => {
        res.dob = new Date(res.dob);
        res.meetingDate = res.meetingDate != null ? new Date(res.meetingDate) : null;
        this.spedStudentDemographics = res;
      },
        err => console.error(err)
      );

      this._adminPlacementService.getAdminPlacement(this.selectedDashboardDocument.adminPlacementId).subscribe((res: IAdminPlacement) => {
        this.adminPlacement = res
        this.adminPlacementIsVisible = true;
      },
        err => console.error(err)
      );
      this.SetActiveIepFormType(IepFormTypeEnum.None);
      this.initialIepInfoIsVisible = false;
    } else {
      this.iepApMenuItems = [
        { label: 'Student Search', command: (event: Event) => { this.selectedIepMenuItem(0) } }
      ];
      this.spedStudentDemographics = null;
    }
    this.documentDashboardIsVisible = false;
  }

  rebuildIepMenuItems(iepInstanceId: number) {
    this.showIepMenuItemsSpinner = true;
    this.SetActiveIepFormType(IepFormTypeEnum.None);
    var selectedIepApMenuItem: MenuItem;

    this._iepService.getIepMenuItems(this._baseUrl + 'api/Iep/GetIepMenuItems?iepInstanceId=' + iepInstanceId).subscribe((res: MenuItem[]) => {
      let disabledClonedMenuItems = JSON.parse(JSON.stringify(res));
      for (let item of res) {
        if (item.id != null) {
          item.command = (event: Event) => { this.selectedIepMenuItem(+item.id) }
        }
        if (item.items != null) {
          for (let subItem of item.items as MenuItem[]) {
            if (subItem.label == '+') {
              subItem.command = (event: Event) => { this.createNewFormInstance(item.label?.toString()) }
            }
            else {
              subItem.command = (event: Event) => { this.selectedIepMenuItem(+subItem.id) }
              if (this.selectedFormInstanceId != null && (subItem.id == this.selectedFormInstanceId.toString())) {
                selectedIepApMenuItem = subItem;
              }
            }
          }
        }
      }
      this.iepApMenuItems = res

      //for (let item of disabledClonedMenuItems) {
      //  item.disabled = true;
      //}
      //this.iepApMenuItemsDisabled = disabledClonedMenuItems
      
      if (selectedIepApMenuItem != null) {
        this.selectedIepMenuItem(+selectedIepApMenuItem.id);
      }
      this.showIepMenuItemsSpinner = false;
    },
      err => {
        console.error(err);
        this.showIepMenuItemsSpinner = false;
      }
    );

    ////Menu Items Disabled
    //this._iepService.getIepMenuItems(this._baseUrl + 'api/Iep/GetIepMenuItems?iepInstanceId=' + iepInstanceId).subscribe((res: MenuItem[]) => {
    //  for (let item of res) {
    //    item.disabled = true;
    //  }
    //  this.iepApMenuItemsDisabled = res
    //},
    //  err => console.error(err)
    //);

    this._dashboardDocumentService.getIepStudent(this._baseUrl + 'api/DashboardDocument/GetIEPSpedStudentDemographics?iepInstanceId=' + iepInstanceId).subscribe((res: ISpedStudentDemographics) => {
      res.dob = new Date(res.dob);
      res.meetingDate = res.meetingDate != null ? new Date(res.meetingDate) : null;
      this.spedStudentDemographics = res;
    },
      err => console.error(err)
    );

    this._iepService.getIepInstance(this._baseUrl + 'api/Iep/GetIepInstance?iepInstanceId=' + iepInstanceId).subscribe((res: IIepInstance) => {
      this.selectedIepInstance = res as IIepInstance

      if (this.selectedIepInstance != null) {
        this.selectedIepInstance.addendumDate = this.selectedIepInstance.addendumDate == null ? null : new Date(this.selectedIepInstance.addendumDate);
        this.selectedIepInstance.annualDueDate = this.selectedIepInstance.annualDueDate == null ? null : new Date(this.selectedIepInstance.annualDueDate);
        this.selectedIepInstance.meetingDate = this.selectedIepInstance.meetingDate == null ? null : new Date(this.selectedIepInstance.meetingDate);
        this.selectedIepInstance.nextReconveneDate = this.selectedIepInstance.nextReconveneDate == null ? null : new Date(this.selectedIepInstance.nextReconveneDate);
        this.selectedIepInstance.printedDate = this.selectedIepInstance.printedDate == null ? null : new Date(this.selectedIepInstance.printedDate);
        this.selectedIepInstance.triAnnualDueDate = this.selectedIepInstance.triAnnualDueDate == null ? null : new Date(this.selectedIepInstance.triAnnualDueDate);
        this.selectedIepInstance.validatedDate = this.selectedIepInstance.validatedDate == null ? null : new Date(this.selectedIepInstance.validatedDate);
        this.selectedIepInstance.meetingId = this.selectedIepInstance.meetingId.toString();
      }

    },
      err => console.error(err)
    );
  }

  public refreshSpedStudentDemographics(iepInstanceId: number) {
    this._dashboardDocumentService.getIepStudent(this._baseUrl + 'api/DashboardDocument/GetIEPSpedStudentDemographics?iepInstanceId=' + iepInstanceId).subscribe((res: ISpedStudentDemographics) => {
      res.dob = new Date(res.dob);
      res.meetingDate = res.meetingDate != null ? new Date(res.meetingDate) : null;
      this.spedStudentDemographics = res;
    },
      err => console.error(err)
    );
  }

  public createNewFormInstance(formInstanceType: string) {
    var form: any;
    this.selectedFormInstanceId = 0;
    //var formTypeName: string;

    //if (formInstanceType.includes('  ')) {
    //  formTypeName = formInstanceType.substr(0, formInstanceType.indexOf("  ")).trim();
    //}
    //else {
    //  formTypeName = formInstanceType.trim();
    //}

    switch (formInstanceType.substr(0, formInstanceType.indexOf("  ")).trim()) {
      case 'Accommodations':
        form = {} as IFormAccomodations;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formAccomodationsService.insertUpdateFormAccomodations(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Age Of Majority 17':
        form = {} as IFormAgeOfMajority17;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formAgeOfMajority17Service.insertUpdateFormAgeOfMajority17(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Age Of Majority 18':
        form = {} as IFormAgeOfMajority18;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formAgeOfMajority18Service.insertUpdateFormAgeOfMajority18(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Assessment Team Summary':
        form = {} as IFormAssessmentTeamSummary;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formAssessmentTeamSummaryService.insertUpdateFormAssessmentTeamSummary(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Authorization for Disclosure':
        form = {} as IFormAuthorizationForDisclosure;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formAuthorizationForDisclosureService.insertUpdateFormAuthorizationForDisclosure(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Behavior Plan':
        form = {} as IFormBehaviorPlan;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        form.date = this.selectedDashboardDocument.meetingDate;
        this._formBehaviorPlanService.insertUpdateFormBehaviorPlan(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'California Assessment Test':
        form = {} as IFormCaliforniaAssessmentTest;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formCaliforniaAssessmentTestService.insertUpdateFormCaliforniaAssessmentTest(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Conference Follow-Up':
        form = {} as IFormConferenceFollowup;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formConferenceFollowupService.insertUpdateFormConferenceFollowup(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Conference Invitation':
        form = {} as IFormConferenceInvitation;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formConferenceInvitationService.insertUpdateFormConferenceInvitation(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'EL Reclassification':
        form = {} as IFormELReclassification;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formELReclassificationService.insertUpdateFormELReclassification(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'ESY Survey':
        form = {} as IFormESYSurvey;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formESYSurveyService.insertUpdateFormESYSurvey(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'ESY Eligibility Worksheet':
        form = {} as IFormESYEligibilityWorksheet;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formESYEligibilityWorksheetService.insertUpdateFormESYEligibilityWorksheet(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Goals and Benchmarks':
        form = {} as IFormGoalsAndBenchmarks;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        form.areaAddressed = '23'; //Pending
        this._formGoalsAndBenchmarksService.insertUpdateFormGoalsAndBenchmarks(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Individualized Transition Plan':
      case 'Transition Plan':
        form = {} as IFormIndividualizedTransitionPlan;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        form.currentAge = this.spedStudentDemographics.ageOnMeetingDate == null ? null : this.spedStudentDemographics.ageOnMeetingDate;
        form.planFilledDate = this.selectedIepInstance.meetingDate == null ? null : new Date(this.selectedIepInstance.meetingDate);
        this._formIndividualizedTransitionPlanService.insertUpdateFormIndividualizedTransitionPlan(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'LAGO':
        form = {} as IFormLAGO;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formLAGOService.insertUpdateFormLAGO(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Manifestation Determination':
        form = {} as IFormManifestationDetermination;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        form.updatedOn = new Date();
        this._formManifestationDeterminationService.insertUpdateFormManifestationDetermination(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Meeting Sign-In Sheet':
        form = {} as IFormMeetingSignIn;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formMeetingSignInService.insertUpdateFormMeetingSignIn(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Meeting Notification':
        form = {} as IFormConferenceInvitation;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formConferenceInvitationService.insertUpdateFormConferenceInvitation(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Notes':
        form = {} as IFormNotes;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formNotesService.insertUpdateFormNotes(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Notice of Intent':
        form = {} as IFormNoticeOfIntent;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formNoticeOfIntentService.insertUpdateFormNoticeOfIntent(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Notification Of Appeal':
        form = {} as IFormNotificationOfAppeal;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formNotificationOfAppealService.insertUpdateFormNotificationOfAppeal(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Permission to Assess':
        form = {} as IFormPermissionToAssess;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formPermissionToAssessService.insertUpdateFormPermissionToAssess(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Permission to Assess Reminder':
        form = {} as IFormPermToAssessRemind;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formPermToAssessRemindService.insertUpdateFormPermToAssessRemind(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Planning for the Future':
        form = {} as IFormPlanningForTheFuture;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formPlanningForTheFutureService.insertUpdateFormPlanningForTheFuture(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Present Levels':
        form = {} as IFormPresentLevels;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formPresentLevelsService.insertUpdateFormPresentLevels(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      //case 'Psychomotor Observation':
      //form = {} as IForm;
      //form.id = 0;
      //form.iepId = this.selectedDashboardDocument.iepId;
      //form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
      //form.iepFormInstanceId = 0;
      //form.localStudentId = this.selectedStudent.localStudentId;
      //form.ssid = this.selectedStudent.ssid;
      //form.studentName = this.selectedStudent.studentName;
      //this._form.save(form, 0, new Date()).subscribe(
      //  (successString: string) => {
      //    let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successString }
      //    this.addMessage(successMessage);
      //    this.selectedFormInstanceId = Number(successString);
      //    this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
      //  },
      //  (error) => {
      //    let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
      //    this.addMessage(errorMessage);
      //  }
      //)
      //break;
      case 'Revoking Consent':
        form = {} as IFormRevokingConsent;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formRevokingConsentService.insertUpdateFormRevokingConsent(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Signature Form':
        form = {} as IFormSignature;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formSignatureService.insertUpdateFormSignature(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Special Factors':
        form = {} as IFormSpecialFactors;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formSpecialFactorsService.insertUpdateFormSpecialFactors(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Student Information':
        form = {} as IFormStudentInformation;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formStudentInformationService.insertUpdateFormStudentInformation(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Summary of Performance':
        form = {} as IFormSummaryOfPerformance;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formSummaryOfPerformanceService.insertUpdateFormSummaryOfPerformance(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Surrogate Parent Meeting':
        form = {} as IFormSurrogateParentAppointment;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formSurrogateParentAppointmentService.insertUpdateFormSurrogateParentAppointment(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Vision and Hearing':
        form = {} as IFormVisionHearing;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this._formVisionHearingService.insertUpdateFormVisionHearing(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;
      case 'Emergency Services Options':
        form = {} as IFormEmergencyServicesOptions;
        form.id = 0;
        form.iepId = this.selectedDashboardDocument.iepId;
        form.iepInstanceId = this.selectedDashboardDocument.iepInstanceId;
        form.iepFormInstanceId = 0;
        form.localStudentId = this.selectedStudent.localStudentId;
        form.ssid = this.selectedStudent.ssid;
        form.studentName = this.selectedStudent.studentName;
        this.formEmergencyServicesOptionsService.insertUpdateFormEmergencyServices(form).subscribe(
          (successValue: any) => {
            let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: successValue.toString() }
            this.addMessage(successMessage);
            this.selectedFormInstanceId = Number(successValue);
            this.rebuildIepMenuItems(this.selectedDashboardDocument.iepInstanceId);
          },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
        break;

      default:

        break;
    }

  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [];

    this.messages = [...this.messages, msg];

  }

  clearMessages() {
    this.messages = [];
  }

  public selectedIepMenuItem(formInstanceId: number) {
    if (formInstanceId == 0) {
      this.selectedStudent = null;
      this.iepApMenuItems = this.studentSearchMenuItems;
      this.activityLogs = null;
      this.studentSearchIsVisible = true;
      this.iepInformationIsVisible = false;
      this.adminPlacementIsVisible = false;
      this.initialIepInfoIsVisible = false;
      this.SetActiveIepFormType(IepFormTypeEnum.None);
    }
    else if (formInstanceId == -1) {
      this.studentSearchIsVisible = false;
      this.iepInformationIsVisible = true;
      this.adminPlacementIsVisible = false;
      this.initialIepInfoIsVisible = false;
      this.SetActiveIepFormType(IepFormTypeEnum.None);
    }
    else {
      this.studentSearchIsVisible = false;
      this.iepInformationIsVisible = false;
      this.adminPlacementIsVisible = false;
      this.initialIepInfoIsVisible = false;
      this.SetActiveIepFormType(IepFormTypeEnum.None);
      if (formInstanceId > 0) {

        this._iepService.GetSelectedFormDetails(this._baseUrl + 'api/Iep/GetSelectedFormDetails?formInstanceId=' + formInstanceId).subscribe((res: IFormDetails) => {
          this.selectedFormDetails = res;

          switch (this.selectedFormDetails.controllerName) {
            case "FormAccommodations":
              this.SetActiveIepFormType(IepFormTypeEnum.FormAccomodations);
              break;
            case "FormAgeOfMajority17":
              this.SetActiveIepFormType(IepFormTypeEnum.FormAgeOfMajority17);
              break;
            case "FormAgeOfMajority18":
              this.SetActiveIepFormType(IepFormTypeEnum.FormAgeOfMajority18);
              break;
            case "FormAssessmentTeamSummary":
              this.SetActiveIepFormType(IepFormTypeEnum.FormAssessmentTeamSummary);
              break;
            case "FormAuthorizationForDisclosure":
              this.SetActiveIepFormType(IepFormTypeEnum.FormAuthorizationForDisclosure);
              break;
            case "FormBehaviorPlan":
              this.SetActiveIepFormType(IepFormTypeEnum.FormBehaviorPlan);
              break;
            case "FormCaliforniaAssessmentTest":
              this.SetActiveIepFormType(IepFormTypeEnum.FormCaliforniaAssessmentTest);
              break;
            case "FormConferenceFollowup":
              this.SetActiveIepFormType(IepFormTypeEnum.FormConferenceFollowup);
              break;
            case "FormConferenceInvitation":
              this.SetActiveIepFormType(IepFormTypeEnum.FormConferenceInvitation);
              break;
            case "FormELReclassification":
              this.SetActiveIepFormType(IepFormTypeEnum.FormELReclassification);
              break;
            case "FormESYSurvey":
              this.SetActiveIepFormType(IepFormTypeEnum.FormESYSurvey);
              break;
            case "FormESYEligibilityWorksheet":
              this.SetActiveIepFormType(IepFormTypeEnum.FormESYEligibilityWorksheet);
              break;
            case "FormGoalsAndBenchmarks":
              this.SetActiveIepFormType(IepFormTypeEnum.FormGoalsAndBenchmarks);
              break;
            case "FormIndividualizedTransitionPlan":
              this.SetActiveIepFormType(IepFormTypeEnum.FormIndividualizedTransitionPlan);
              break;
            case "FormLAGO":
              this.SetActiveIepFormType(IepFormTypeEnum.FormLAGO);
              break;
            case "FormManifestationDetermination":
              this.SetActiveIepFormType(IepFormTypeEnum.FormManifestationDetermination);
              break;
            case "FormMeetingSignInSheet":
              this.SetActiveIepFormType(IepFormTypeEnum.FormMeetingSignInSheet);
              break;
            case "FormNotes":
              this.SetActiveIepFormType(IepFormTypeEnum.FormNotes);
              break;
            case "FormNoticeOfIntent":
              this.SetActiveIepFormType(IepFormTypeEnum.FormNoticeOfIntent);
              break;
            case "FormNotificationOfAppeal":
              this.SetActiveIepFormType(IepFormTypeEnum.FormNotificationOfAppeal);
              break;
            case "FormPermissionToAssess":
              this.SetActiveIepFormType(IepFormTypeEnum.FormPermissionToAssess);
              break;
            case "FormPermToAssessRemind":
              this.SetActiveIepFormType(IepFormTypeEnum.FormPermToAssessRemind);
              break;
            case "FormPlanningForTheFuture":
              this.SetActiveIepFormType(IepFormTypeEnum.FormPlanningForTheFuture);
              break;
            case "FormPresentLevels":
              this.SetActiveIepFormType(IepFormTypeEnum.FormPresentLevels);
              break;
            case "FormPsychomotorObservation":
              this.SetActiveIepFormType(IepFormTypeEnum.FormPsychomotorObservation);
              break;
            case "FormRevokingConsent":
              this.SetActiveIepFormType(IepFormTypeEnum.FormRevokingConsent);
              break;
            case "FormSignature":
              this.SetActiveIepFormType(IepFormTypeEnum.FormSignature);
              break;
            case "FormSpecialFactors":
              this.SetActiveIepFormType(IepFormTypeEnum.FormSpecialFactors);
              break;
            case "FormStudentInformation":
              this.SetActiveIepFormType(IepFormTypeEnum.FormStudentInformation);
              break;
            case "FormSummaryOfPerformance":
              this.SetActiveIepFormType(IepFormTypeEnum.FormSummaryOfPerformance);
              break;
            case "FormSurrogateParentAppointment":
              this.SetActiveIepFormType(IepFormTypeEnum.FormSurrogateParentAppointment);
              break;
            case "FormVisionHearing":
              this.SetActiveIepFormType(IepFormTypeEnum.FormVisionHearing);
              break;
            case "FormEmergencyServicesOptions":
              this.SetActiveIepFormType(IepFormTypeEnum.FormEmergencyServicesOptions);
              break;
            case "FormRevokingConsent":
              this.SetActiveIepFormType(IepFormTypeEnum.FormRevokingConsent);
              break;
          }
        })
      }
    }
  }

  SetActiveIepFormType(selectedFormType: IepFormTypeEnum) {
    this.adminPlacementIsVisible = false;
    this.iepFormControl.formAccomodationsIsVisible = false;
    this.iepFormControl.formAgeOfMajority17IsVisible = false;
    this.iepFormControl.formAgeOfMajority18IsVisible = false;
    this.iepFormControl.formAssessmentTeamSummaryReportIsVisible = false;
    this.iepFormControl.formAuthorizationForDisclosureIsVisible = false;
    this.iepFormControl.formBehaviorPlanIsVisible = false;
    this.iepFormControl.formCaliforniaAssessmentTestIsVisible = false;
    this.iepFormControl.formConferenceFollowupIsVisible = false;
    this.iepFormControl.formConferenceInvitationIsVisible = false;
    this.iepFormControl.formELReclassificationIsVisible = false;
    this.iepFormControl.formESYSurveyIsVisible = false;
    this.iepFormControl.formESYEligibilityWorksheetIsVisible = false;
    this.iepFormControl.formGoalsAndBenchmarksIsVisible = false;
    this.iepFormControl.formIndividualizedTransitionPlanIsVisible = false;
    this.iepFormControl.formLAGOIsVisible = false;
    this.iepFormControl.formManifestationDeterminationIsVisible = false;
    this.iepFormControl.formMeetingSignInSheetIsVisible = false;
    this.iepFormControl.formNotesIsVisible = false;
    this.iepFormControl.formNoticeOfIntentIsVisible = false;
    this.iepFormControl.formNotificationOfAppealIsVisible = false;
    this.iepFormControl.formPermissionToAssessIsVisible = false;
    this.iepFormControl.formPermToAssessRemindIsVisible = false;
    this.iepFormControl.formPlanningForTheFutureIsVisible = false;
    this.iepFormControl.formPresentLevelsIsVisible = false;
    this.iepFormControl.formPsychomotorObservationIsVisible = false;
    this.iepFormControl.formRevokingConsentIsVisible = false;
    this.iepFormControl.formSignatureIsVisible = false;
    this.iepFormControl.formSpecialFactorsIsVisible = false;
    this.iepFormControl.formStudentInformationIsVisible = false;
    this.iepFormControl.formSummaryOfPerformanceIsVisible = false;
    this.iepFormControl.formSurrogateParentAppointmentIsVisible = false;
    this.iepFormControl.formVisionHearingIsVisible = false;
    this.iepFormControl.formEmergencyServiceOptionsIsVisible = false;

    switch (selectedFormType) {
      case IepFormTypeEnum.FormAccomodations:
        this.iepFormControl.formAccomodationsIsVisible = true;
        break;
      case IepFormTypeEnum.FormAgeOfMajority17:
        this.iepFormControl.formAgeOfMajority17IsVisible = true;
        break;
      case IepFormTypeEnum.FormAgeOfMajority18:
        this.iepFormControl.formAgeOfMajority18IsVisible = true;
        break;
      case IepFormTypeEnum.FormAssessmentTeamSummary:
        this.iepFormControl.formAssessmentTeamSummaryReportIsVisible = true;
        break;
      case IepFormTypeEnum.FormAuthorizationForDisclosure:
        this.iepFormControl.formAuthorizationForDisclosureIsVisible = true;
        break;
      case IepFormTypeEnum.FormBehaviorPlan:
        this.iepFormControl.formBehaviorPlanIsVisible = true;
        break;
      case IepFormTypeEnum.FormCaliforniaAssessmentTest:
        this.iepFormControl.formCaliforniaAssessmentTestIsVisible = true;
        break;
      case IepFormTypeEnum.FormConferenceFollowup:
        this.iepFormControl.formConferenceFollowupIsVisible = true;
        break;
      case IepFormTypeEnum.FormConferenceInvitation:
        this.iepFormControl.formConferenceInvitationIsVisible = true;
        break;
      case IepFormTypeEnum.FormELReclassification:
        this.iepFormControl.formELReclassificationIsVisible = true;
        break;
      case IepFormTypeEnum.FormESYSurvey:
        this.iepFormControl.formESYSurveyIsVisible = true;
        break;
      case IepFormTypeEnum.FormESYEligibilityWorksheet:
        this.iepFormControl.formESYEligibilityWorksheetIsVisible = true;
        break;
      case IepFormTypeEnum.FormGoalsAndBenchmarks:
        this.iepFormControl.formGoalsAndBenchmarksIsVisible = true;
        break;
      case IepFormTypeEnum.FormIndividualizedTransitionPlan:
        this.iepFormControl.formIndividualizedTransitionPlanIsVisible = true;
        break;
      case IepFormTypeEnum.FormLAGO:
        this.iepFormControl.formLAGOIsVisible = true;
        break;
      case IepFormTypeEnum.FormManifestationDetermination:
        this.iepFormControl.formManifestationDeterminationIsVisible = true;
        break;
      case IepFormTypeEnum.FormMeetingSignInSheet:
        this.iepFormControl.formMeetingSignInSheetIsVisible = true;
        break;
      case IepFormTypeEnum.FormNotes:
        this.iepFormControl.formNotesIsVisible = true;
        break;
      case IepFormTypeEnum.FormNoticeOfIntent:
        this.iepFormControl.formNoticeOfIntentIsVisible = true;
        break;
      case IepFormTypeEnum.FormNotificationOfAppeal:
        this.iepFormControl.formNotificationOfAppealIsVisible = true;
        break;
      case IepFormTypeEnum.FormPermissionToAssess:
        this.iepFormControl.formPermissionToAssessIsVisible = true;
        break;
      case IepFormTypeEnum.FormPermToAssessRemind:
        this.iepFormControl.formPermToAssessRemindIsVisible = true;
        break;
      case IepFormTypeEnum.FormPlanningForTheFuture:
        this.iepFormControl.formPlanningForTheFutureIsVisible = true;
        break;
      case IepFormTypeEnum.FormPresentLevels:
        this.iepFormControl.formPresentLevelsIsVisible = true;
        break;
      case IepFormTypeEnum.FormPsychomotorObservation:
        this.iepFormControl.formPsychomotorObservationIsVisible = true;
        break;
      case IepFormTypeEnum.FormRevokingConsent:
        this.iepFormControl.formRevokingConsentIsVisible = true;
        break;
      case IepFormTypeEnum.FormSignature:
        this.iepFormControl.formSignatureIsVisible = true;
        break;
      case IepFormTypeEnum.FormSpecialFactors:
        this.iepFormControl.formSpecialFactorsIsVisible = true;
        break;
      case IepFormTypeEnum.FormStudentInformation:
        this.iepFormControl.formStudentInformationIsVisible = true;
        break;
      case IepFormTypeEnum.FormSummaryOfPerformance:
        this.iepFormControl.formSummaryOfPerformanceIsVisible = true;
        break;
      case IepFormTypeEnum.FormSurrogateParentAppointment:
        this.iepFormControl.formSurrogateParentAppointmentIsVisible = true;
        break;
      case IepFormTypeEnum.FormVisionHearing:
        this.iepFormControl.formVisionHearingIsVisible = true;
        break;
      case IepFormTypeEnum.FormEmergencyServicesOptions:
        this.iepFormControl.formEmergencyServiceOptionsIsVisible = true;
        break;
      case IepFormTypeEnum.None:
      default:
        break;
    }
  }

  printNonFormCommon(prefix: string, reportFileName: string, reportParamArray: IReportParameter[]) {
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = prefix;
    reportRequest.reportFileName = reportFileName;
    reportRequest.reportSpecificParameterArray = reportParamArray;
    try {
      this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
        var binaryString = window.atob(res.base64FileContent);
        var stringLength = binaryString.length;
        var bytes = new Uint8Array(stringLength);
        for (var i = 0; i < stringLength; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        saveAs(new Blob([bytes], { type: 'application/pdf' }), res.fileName);
      },
        err => {
          console.error(err);
        }
      );
    }
    catch (err) { alert("Error while attempting to print pdf: " + err.message); }
  }


  printFormCommon(reportPath: string, reportParamArray: IReportParameter[]) {
    var prefix: string = "";
    var reportFileName: string;
    try {
      var slashIndex: number = reportPath.lastIndexOf('/');
      var totalLength: number = reportPath.length;

      prefix = reportPath.substring(1, slashIndex);
      reportFileName = reportPath.substring(slashIndex + 1, totalLength);
    }
    catch{
      reportFileName = reportPath;
    }

    reportParamArray.push({ parameterName: 'ReportPath', parameterValue: reportFileName });

    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = prefix;
    reportRequest.reportFileName = reportFileName;
    reportRequest.reportSpecificParameterArray = reportParamArray;
    try {
      this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
        var binaryString = window.atob(res.base64FileContent);
        var stringLength = binaryString.length;
        var bytes = new Uint8Array(stringLength);
        for (var i = 0; i < stringLength; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        saveAs(new Blob([bytes], { type: 'application/pdf' }), res.fileName);
      },
        err => {
          console.error(err);
        }
      );
    }
    catch (err) { alert("Error while attempting to print pdf: " + err.message); }
  }
}


